import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "./ApiUtils";

const whatsappGroupApiUrl = `${baseApiUrl}/api/WhatsappGroups`;

export const getWhatsappGroups = async (name = "", orderBy) => {
    return await httpRequest(fetchWhatsappGroups.bind(this, name, orderBy));
}

const fetchWhatsappGroups = async (name, orderBy) => {
    let config = getHttpHeaders();
    return await axios.get(`${whatsappGroupApiUrl}?Name=${name}&OrderBy=${orderBy}`, config);
}

export const getWhatsappGroupById = async (id) => {
    return await httpRequest(fetchWhatsappGroupById.bind(this, id));
}

const fetchWhatsappGroupById = async (id) => {
    let config = getHttpHeaders();
    return await axios.get(`${whatsappGroupApiUrl}/${id}`, config);
}

export const addWhatsappGroup = async (whatsappgroup) => {
    return await httpRequest(postWhatsappGroup.bind(this, whatsappgroup));
}

const postWhatsappGroup = async (whatsappgroup) => {
    let config = getHttpHeaders();
    return await axios.post(`${whatsappGroupApiUrl}`, whatsappgroup, config);
}

export const updateWhatsappGroup = async (whatsappgroup) => {
    return await httpRequest(putWhatsappGroup.bind(this, whatsappgroup));   
}

const putWhatsappGroup = async (whatsappgroup) => {
    let config = getHttpHeaders();
    return await axios.put(`${whatsappGroupApiUrl}`, whatsappgroup, config);
}

export const deleteWhatsappGroup = async (id) => {
    return await httpRequest(fetchDeleteWhatsappGroup.bind(this, id));   
}

const fetchDeleteWhatsappGroup = async (id) => {
    let config = getHttpHeaders();
    return await axios.delete(`${whatsappGroupApiUrl}/${id}`, config);
}
